import { createContext } from "react";
import { InvoiceModel, InvoicesConfigModel } from "@jugl-web/rest-api";
import {
  InvoicesAvailableAction,
  InvoicesTableActions,
  InvoicesTableNavigateFn,
} from "@jugl-web/domain-resources/invoices/types";
import { UseSelectedItemsReturn } from "../hooks/useSelectedItems";

export interface InvoicesTableContextType {
  variant: "all" | "task" | "customer";
  items: InvoiceModel[] | null;
  selected: UseSelectedItemsReturn;
  isLoading: boolean;
  isInitialLoading: boolean;
  hasMore: boolean;
  totalEntries: number;
  isInitialized: boolean;
  searchQuery: string | undefined;
  taskId: string | undefined;
  filters: Record<string, string> | undefined;
  entity: { id: string; name: string; img?: string | null };
  config: InvoicesConfigModel | undefined;
  actions: InvoicesTableActions;
  isGuest: boolean;
  availableActions: InvoicesAvailableAction[];
  loadMoreInvoices: (
    shouldReset?: boolean,
    clearSearchValue?: boolean,
    searchValue?: string
  ) => Promise<void>;
  handleDeleteInvoice: (invoiceIds: string | string[]) => Promise<void>;
  addItem: (item: InvoiceModel) => void;
  onNavigate?: InvoicesTableNavigateFn;
}

export const InvoicesTableContext =
  createContext<InvoicesTableContextType | null>(null);
